const FuzzyReaction = require('../bootstrap').FuzzyReaction;
const AppDispatcher = FuzzyReaction.Dispatcher;
const AppActionConstants = require('../constants/AppActionConstants');
const assign = require('object-assign');
const ModelStore = FuzzyReaction.Stores.ModelStore;
const ActionTypes = AppActionConstants.ActionTypes.messages;

/**
 * Data stores
 * @type {Array}
 * @private
 */
let _resourceData = {};
let _resourceListData = [];

/**
 * User store logic
 *
 * @type {*|exports}
 */
const SubscribersStore = assign({}, ModelStore, {
    getResource: function () {
        return _resourceData;
    },

    getResourceListData: function () {
        return _resourceListData;
    },

    getResourceById: function (id) {
        // http://stackoverflow.com/questions/12553274/getting-index-of-an-arrays-element-based-on-its-properties
        const index = _resourceListData.map(function (item) {
            return item.id;
        }).indexOf(Number(id));

        return _resourceListData[index];
    }
});

/**
 * Event Listeners
 */
SubscribersStore.dispatchToken = AppDispatcher.register(function (action) {
    switch (action.type) {
        case 'USERS_LISTED':
            _resourceListData = action.data;

            SubscribersStore.emitChange();
            break;
        case ActionTypes.REVERIFIED_SUBSCRIPTION:
            // Find the index of this subscriber in the list.
            const index = _resourceListData.map(function (item) {
                return item.id;
            }).indexOf(Number(action.data.id));

            // Replace the item in the list with the new item.
            _resourceListData[index] = action.data;
            _resourceData = action.data;

            SubscribersStore.emitChange();
            break;
    }
});

module.exports = SubscribersStore;
